/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".webcam-display video{max-width:100%;max-height:300px}.webcam-wrapper{margin-bottom:20px}\n/*# sourceMappingURL=photo-dialog.component.css.map*/"];
export { styles as styles };
